@layer components {
  :root {
    --container-width: 90ch;
    --container-padding-inline: var(--space-md);

    @media (min-width: 768px) {
      --container-padding-inline: var(--space-lg);
    }

    @media (min-width: 1024px) {
      --container-padding-inline: var(--space-xl);
    }
  }

  .container {
    max-width: var(--container-width);
    margin-inline: auto;
    padding-inline: var(--container-padding-inline);

    display: flex;
    flex-direction: column;
    align-items: stretch;

    & > *:has(pre) {
      max-width: calc(100vw - 2 * var(--container-padding-inline));
    }

    & > * + main {
      margin-block-start: var(--space-xl);
    }
  }

  .header {
    margin-block-start: var(--space-sm);
    margin-block-end: var(--space-xl);

    display: flex;
    flex-direction: column;

    &:not(:has(:not(h1))) {
      align-items: center;
    }
  }

  .nav {
    & > section {
      background-color: var(--bg-secondary);
      padding: var(--space-md);
      border-radius: var(--radius-md);

      & > * + * {
        margin-block-start: var(--space-sm);
      }
    }

    @media (min-width: 1200px) {
      & {
        position: fixed;
        right: 0;
        top: 0;
        height: 100vh;
        width: calc((100vw - var(--container-width)) / 2 * 0.8);

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        container-type: inline-size;

        & > * {
          width: 100%;
          max-height: 100%;

          overflow-y: auto;
        }

        @container (width < 12rem) {
          :where(h2, h3, h4) {
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100px;
            overflow: hidden;
          }
        }
      }

      & > section {
        background-color: inherit;
      }
    }

    :where(h2, h3) {
      margin: 0;
    }

    :where(h2) {
      font-family: var(--font-system);
      color: var(--color-text-muted);
    }

    h2 {
      font-size: var(--text-lg);
    }
  }
}
